import { produce } from "immer";
import { Reducer } from "redux";
import { IAdminUser } from "src/core/adminUser/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IAdminUserState {
  adminUsers: IAdminUser[];
  loading: boolean;
  error: any;
}

const initialState: IAdminUserState = {
  adminUsers: [],
  loading: false,
  error: null,
};

/*
 * action types
 */
const FETCH_REQUESTED = "admin-user/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "admin-user/FETCH_SUCCEEDED";
const FETCH_FAILED = "admin-user/FETCH_FAILED";
const POLLING_START_REQUESTED = "admin-user/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "admin-user/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<IAdminUser[]>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IAdminUserState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IAdminUserState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const { payload } = action;
        draft.adminUsers = payload;
        draft.loading = false;
        draft.error = null;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
